export default __webpack_public_path__ + "static/Entenda0024-fb7ec6fb449705248e8374065983f070.jpg";